import { Adresse } from "../types/models/adresse";
import { SuggestionAdresse } from "../types/models/suggestion-adresse";
import { ItineraireResponse } from "../types/models/itineraire-response";
import { HttpClient } from "./http-client";

// Recherche d'adresses / POI et calcul d'itinéraire, centralisés côté backend
// KMS7 (Google Places). Les appels passent par le proxy same-origin /backend-api
// qui injecte l'access token Keycloak côté serveur : aucun en-tête Authorization
// n'est ajouté ici.
export class AdresseService {
  private readonly http: HttpClient;

  constructor(apiUrl: string) {
    this.http = new HttpClient(apiUrl);
  }

  // GET /api/adresses/suggestions — remplace Nominatim. Ne pas appeler en dessous
  // de 3 caractères (à la charge de l'appelant).
  public getSuggestions = async (
    texte: string,
    langue = "fr",
    nombre = 5,
    signal?: AbortSignal,
  ): Promise<SuggestionAdresse[]> =>
    this.http.get<SuggestionAdresse[]>("/api/adresses/suggestions", {
      query: { texte, langue, nombre },
      signal,
    });

  // POST /api/adresses/itineraire — remplace OSRM. `adresses` ordonnées, min. 2.
  // `placeId` n'est envoyé que s'il est présent (adresse issue d'une suggestion).
  public calculerItineraire = async (
    adresses: Adresse[],
  ): Promise<ItineraireResponse> =>
    this.http.post<ItineraireResponse>("/api/adresses/itineraire", {
      adresses: adresses.map(toAdressePayload),
    });
}

/** N'inclut `placeId` que s'il existe (adresse manuelle / favori ⇒ omis). */
const toAdressePayload = (adresse: Adresse) => {
  const { rue, numero, boite, codePostal, ville, pays, placeId } = adresse;
  const base = { rue, numero, boite, codePostal, ville, pays };

  return placeId ? { ...base, placeId } : base;
};
